import React from "react";
import CoreComponent4 from "../../../assets/Sub-component/CoreComponent4";
import HeaderThree from "../../../components/header/HeaderThree";
import { Helmet } from "react-helmet";


import app from "../../../assets/Iphone/services-iphone/App-Development.svg";
import CoreComponent10 from "../../../assets/Sub-component/CoreComponent10";
import CoreComponent8 from "../../../assets/Sub-component/CoreComponent8";

import driven from "../../../assets/Android-app-dev/Our-agile-dev/Fixed-eng.svg";
import hour from "../../../assets/Android-app-dev/Our-agile-dev/Hourly-eng.svg";
import hires from "../../../assets/Android-app-dev/Our-agile-dev/Hire.svg";

import OurLatestBlogs from "../../../assets/Sub-component/OurLatestBlogs";
import FooterTwo from "../../../components/footer/FooterTwo";
import CopyRightTwo from "../../../components/footer/CopyRightTwo";
import Banner from "../../../assets/Sub-component/Banner";
import CoreComponent13 from "../../../assets/Sub-component/CoreComponent13";
import CoreComponent2 from "../../../assets/Sub-component/CoreComponent2";



import appdev from "../../../assets/Android-app-dev/Keen-to-know/App-Development.svg";
import blockchaindev from "../../../assets/Android-app-dev/Keen-to-know/Blockchain-Dev.svg";
import game from "../../../assets/Android-app-dev/Keen-to-know/Game-dev.svg";
import watch from "../../../assets/Android-app-dev/Keen-to-know/watch-dev.svg";
import DevelopmentProcessCore from "../../../assets/Sub-component/DevelopmentProcessCore";
import CoreComponent22 from "../../../assets/Sub-component/CoreComponent22";
import IndustriesCore from "../../../assets/Sub-component/IndustriesCore";
import Enterpertises3 from "../../../assets/Sub-component/Enterpertises3";
import { Link } from "react-router-dom";


import Blockchain_For_Decentralized from '../../../assets/Services/Blockchain_app_dev/What_do_we_provide/Blockchain_For_Decentralized.svg'
import Blockchain_Game_Development from '../../../assets/Services/Blockchain_app_dev/What_do_we_provide/Blockchain_Game_Development.svg'
import Blockchain_MLM from '../../../assets/Services/Blockchain_app_dev/What_do_we_provide/Blockchain_MLM.svg'
import Blockchain_Smart_Contract from '../../../assets/Services/Blockchain_app_dev/What_do_we_provide/Blockchain_Smart_Contract.svg'
import Cryptocurrency_Exchange from '../../../assets/Services/Blockchain_app_dev/What_do_we_provide/Cryptocurrency_Exchange.svg'
import DAPP_Development from '../../../assets/Services/Blockchain_app_dev/What_do_we_provide/DAPP_Development.svg'
import NFT_Development from '../../../assets/Services/Blockchain_app_dev/What_do_we_provide/NFT_Development.svg'

import Corda from '../../../assets/Services/Blockchain_app_dev/Technology_stack_used/Corda.svg'
import EOS from '../../../assets/Services/Blockchain_app_dev/Technology_stack_used/EOS.svg'
import Ethereum from '../../../assets/Services/Blockchain_app_dev/Technology_stack_used/Ethereum.svg'
import Hyperledger from '../../../assets/Services/Blockchain_app_dev/Technology_stack_used/Hyperledger.svg'
import hedera from '../../../assets/Services/Blockchain_app_dev/Technology_stack_used/hedera.svg'
import stellar from '../../../assets/Services/Blockchain_app_dev/Technology_stack_used/stellar.svg'

import Healthcare from '../../../assets/Services/Blockchain_app_dev/Industries_we_fue/Healthcare.svg'
import RealEstate from '../../../assets/Services/Blockchain_app_dev/Industries_we_fue/RealEstate.svg'
import Ride_sharing from '../../../assets/Services/Blockchain_app_dev/Industries_we_fue/Ride_sharing.svg'
import Social_Networks from '../../../assets/Services/Blockchain_app_dev/Industries_we_fue/Social_Networks.svg'
import education from '../../../assets/Services/Blockchain_app_dev/Industries_we_fue/education.svg'
import fintech from '../../../assets/Services/Blockchain_app_dev/Industries_we_fue/fintech.svg'

import icon1 from '../../../assets/Services/Blockchain_app_dev/blockchain_app_1.png'
import icon2 from '../../../assets/Services/Blockchain_app_dev/blockchain_2.png'
import FaqHome from "../../../components/faq/FaqHome";
import launchingimage from '../../../assets/Launchingimage.png'
const BlockChainApp = () => {
  const timelineData = [
    {
      heading: "Blockchain Consulting",
      icon: "https://www.techgropse.com/common/images/mobile-app-support-maintenance/analysis-and-research.png",
      content:
        "Benefit from our transparent approach with the impact of blockchain use cases for your organization. We help you from the very beginning of the project, preventing expensive reworks and ensuring that you select a technology stack that fits your business requirements.",
    },
    {
      heading: "User experience and technical design",
      icon: "https://www.techgropse.com/common/images/mobile-app-support-maintenance/analysis-and-research.png",
      content:
        "Our blockchain developers skillfully design a system that is intuitive, easy to use, aesthetically beautiful, and functional. Without having to comprehend the technical subtleties, we navigate using a highly functional application for a seamless experience. ",
    },
    {
      heading: "Enterprise Blockchain Development",
      icon: "https://www.techgropse.com/common/images/mobile-app-support-maintenance/analysis-and-research.png",
      content:
        "Raiden creates enterprise-level blockchain apps that are secure, offer decentralized solutions, and have measurable advantages for your company. A wide range of industries can use these features to seamlessly run their businesses by eliminating intermediaries.",
    },
    {
      heading: "Updating and Modifying",
      icon: "https://www.techgropse.com/common/images/mobile-app-support-maintenance/analysis-and-research.png",
      content:
        "There are always modifications that must be made, and they must be done promptly. We execute projects on schedule and handle them seamlessly.",
    },
    {
      heading: "Deployment",
      icon: "https://www.techgropse.com/common/images/mobile-app-support-maintenance/analysis-and-research.png",
      content:
        "Our expert team builds the whole process with complete advancement and efficiency. We undergo configuration, front-end, back-end, and validation of nodes, including the deployment process. By undergoing pre-launch testing, we validate our process before the final execution for a flawless launch.",
    },
    {
      heading: "Maintenance  ",
      icon: "https://www.techgropse.com/common/images/mobile-app-support-maintenance/analysis-and-research.png",
      content:
        "We track the performance, security audits, and other new updates for maintaining a comprehensive user engagement. The issues are solved in the meantime, ensuring stability and the intuitive functionality of your blockchain technology application.",
    },
    {
      heading: " Migration & Upgrades ",
      icon: "https://www.techgropse.com/common/images/mobile-app-support-maintenance/analysis-and-research.png",
      content:
        "Raiden's blockchain migration streamlines the process of reaching new platforms, updating protocols, and integrating new features to improve functionality and security, as well as optimize your blockchain infrastructure for future growth.",
    },
  ];

  const content3 = [
    {
      title: "An Extensive Overview of App Development",
      desc: "Raiden's development is a blueprint for app resilience, ensuring seamless maintenance and uncompromising performance.",

      loops: [
        {
          line: "div-line",
          icon: appdev,
          title: "Android App Development",
          desc: " We utilize Android’s complete efficiency and made it to function efficiently without causing any flaws on Android-powered gadgets like tablets and smartphones for a complete, reliable experience.",
        },
        {
          line: "div-line2",
          icon: blockchaindev,
          title: "Blockchain App Development",
          desc: "We concentrate on developing decentralized apps (dApps) that run on a blockchain network for improved immutability, security, and transparency that can be validated on several computers.",
        },
        {
          line: "div-line3",
          icon: game,
          title: "Mobile Game App Development",
          desc: "We make mobile games with an emphasis on user interfaces, graphics, character development, and plot to guarantee an engaging gaming experience.",
        },
        {
          line: "div-line4",
          icon: watch,
          title: "Wearable App Development",
          desc: "Raiden uses wearable technology that has sensors to collect data and show it right away. Some examples are fitness trackers, AR/VR headsets, and smartwatches.",
        },
      ],
    },
  ];

  const banner = [
    {
      title: "Curious about what it's like to work here?",
      desc: "A group of skilled developers has been brought together to maximize the efficiency of your business, so prepare to release an application.",
      title2: "Curious about what it's like to work here?",
    },
  ];

  const content = [
    {
      icon: app,
      title: " Web3 ",
      desc: " Enhance your business level with blockchain-powered techniques that provide digital ownership of your entire data. ",
    },
     {
      icon: Blockchain_MLM,
      title: " Public Blockchain ",
      desc: " We enable your business to thrive in the decentralized era by providing a secure, immutable digital ledger that serves as a backbone for innovative Web3.",
    },
     {
      icon: Blockchain_Game_Development,
      title: "Private blockchain  ",
      desc: "We provide the essential privacy and governance needed for sensitive business operations, along with the core benefits of distributed ledger technology.  ",
    },
     {
      icon: Cryptocurrency_Exchange,
      title: "Cryptocurrency  ",
      desc: " A strategic move to expand market penetration, improve productivity, and build relationships with a diverse clientele is integrating cryptocurrency. Raiden makes the impossible possible. ",
    },
     {
      icon: DAPP_Development,
      title: "  DEX",
      desc: "Raiden specializes in developing and incorporating DEX solutions. Empowering decentralized finance by offering unparalleled control, transparency, and security   ",
    },
     {
      icon: Blockchain_For_Decentralized,
      title: " Crypto wallet ",
      desc: " A crypto wallet is more than a place to hold funds; it's your personal portal for digital ownership and interaction. Businesses can securely manage their digital assets. ",
    },
     {
      icon: NFT_Development,
      title: "  NFT Marketplace",
      desc: "  Enabling businesses and creators to explore revenue streams and build communities in the digital ownership economy, leading the way in innovation for unique digital assets.",
    },
     {
      icon: Blockchain_Smart_Contract,
      title: " Smart Contract ",
      desc: "Incorporate smart contracts directly into your operations. We embed these self-executing, secure agreements, transparency, and trust into your digital process  ",
    },
   
  ];
  const comp11 = [
    {
      title: "Have a Blockchain Development App Idea?",
      desc:"Raiden makes your vision a digital success",
    },
  ];

  const corecontent = [
    {
      title: "Our Core Beliefs in Agile Development",
      desc: "Our approach for Blockchain app development  prioritizes rapid, user-centric development. This ensures your vision quickly reaches the market, delivering compelling experiences and driving business impact.",
      icons: [
        {
          icon: driven,
          icontitle: "Outcome-Driven Collaboration",
          icondesc:
            "We offer your business the experience of expert guidance, optimistic performances, low-cost budgets, and support for all your business operations.",
        },
        {
          icon: hour,
          icontitle: "Adaptive Iteration & Growth",
          icondesc:
            "This method works well for projects that change over time because it pays for the work that is actually done.",
        },
        {
          icon: hires,
          icontitle: "Strategic Team Extension",
          icondesc:
            "Raiden’s proficient team of developers endures in your business operations to increase your internal capabilities with targeted expertise.",
        },
      ],
    },
  ];

  const technologiesstack = [
    {
      title: "Healthcare ",
      icon:  Healthcare,
      desc: " Our blockchain reduces the risk of data breaches and medical errors by offering secure patient and other data records. Smart contracts process insurance claim benefits, which are safe and efficient.",
    },
    {
      title: "Real estate ",
      icon:  RealEstate,
      desc: " Blockchain generates trust for your business among people by creating verifiable property ownership through the tokenization method. It is entirely safe and advantageous to automate real estate agreements, escrows, and transactions.",
    },
    {
      title: " FinTech",
      icon:  fintech,
      desc: " This cryptographic security, which safeguards against hackers and middlemen while preserving data integrity, offers high levels of trust. Blockchain facilitated international payments and reduced fees through peer-to-peer transactions. ",
    },
    {
      title: "Educational ",
      icon:  education,
      desc: " Enabling decentralized digital education for students, which effectively provides with the tutors. Maintaining an unchangeable record of students’ academic records and institutions makes it simple to confirm their qualifications.",
    },
    {
      title: "Social network ",
      icon:  Social_Networks,
      desc: " Our blockchain establishes ownership over your data in this rapidly changing social network environment and verifies your identity and authenticity. This unchangeable technology benefits both users and your business.",
    },
    {
      title: "Ride-sharing services ",
      icon: Ride_sharing ,
      desc: " Applications of blockchain technology combined with ride-sharing services have the potential to provide data security, transparency, and the capacity to operate your company profitably and optimistically. ",
    },
  ];

  const industries = [
    {
      title: "ethereum ",
      icon:Ethereum ,
      desc: " The experience of low-cost, scalable, and low-fee maintenance is made possible by developing applications that integrate Ethereum, allowing for active user engagement.",
    },
    {
      title: " Hyperledger ",
      icon:Hyperledger ,
      desc: "Hyperledger is designed for businesses that value privacy, high transaction volume, and network control to maintain accountability and trust. It offers blockchain-based solutions for their needs.   ",
    },
    {
      title: "  Corda",
      icon: Corda,
      desc: " Corda is an organization focused on the DLT industry, particularly in the field of finances. It maintains their stability in regulatory environments and creates a foundation by removing the need for intermediaries. ",
    },
    {
      title: "  EOS",
      icon: EOS,
      desc: "EOS specializes in providing high scalability and proceeds with low transaction fees, which can make millions of transactions per second. Its holders can access the vote network upgrades and policies.  ",
    },
    {
      title: "Hedera  ",
      icon: hedera,
      desc: " Hedera is known as the public distributed ledger technology that works as an alternative method to the traditional blockchain, encouraging speed, security, and comparatively low fees.  ",
    },
    {
      title: " Stellar ",
      icon:stellar ,
      desc: "It is actively a payment-focused network for regulating fast but cost-efficient cross-border payments, which benefits businesses. Users can access and manage their own assets in this financial space.  ",
    },
  ];

  return (
    <><img className="Bg-image"
  src={launchingimage} 
  
  alt="Launching"
/>

    <div className="main-page-wrapper">
      <Helmet>
        <title>Customer Support || Deski-Saas & Software React Template</title>
      </Helmet>

      <HeaderThree />

      <div
        className=" container  d-flex align-items-center justify-content-center flex-column  topheader-margin"
        style={{ minHeight: "100vh" }}
      >
        <h1 className="h1-heading lh-sm fw-bold text-center">Blockchain</h1>
        <p className=" mt-3  h1-para lh-base">
         Enacting the digital world with leading edge

        </p>
        <p className="text-center mt-4 mb-4  h1-para lh-base">
          Raiden—your proficient blockchain application development company
        </p>
        <p className="h1-para">Experience Raiden's 10 years of expertise in our commitment to providing an efficient website and maintaining it with  100% satisfaction for your business. Beyond the web, our blockchain technology creates unique, secure, and scalable solutions.</p>
        <div className="d-flex ">
          <Link to="/request-quote">
            <button className="h1-para mt-3 py-lg-3 py-2 px-lg-4 px-3 btn-gradient border-0 text-white rounded-4">
              Get Your Free Quote
            </button>
          </Link>
        </div>
      </div>
      <div className=" bg-light">
        <div className=" container pt-60 padt padb pb-60">
          <div className=" row mb-80 marb  ">
            <h2 className="col-lg-6 h2-heading mb-3 mb-lg-0 lh-sm">
            Innovation-Driven Services for Your Blockchain Adventure

            </h2>
            <p className="col-lg-6 h1-para lh-base">
             As a top-tier blockchain development company, we deliver expert engineering solutions to modernize and enhance your blockchain infrastructure. Our skilled developers craft robust blockchain systems designed to maximize the success of your business operations.
            </p>
          </div>
          <div>
            <CoreComponent4 content={content} />
          </div>
        </div>
      </div>

      <div className="container pt-80 padt ">
        <div className=" row">
          <div className="col-lg-5 text-center">
            <img src={icon1} style={{ width: "75%" }} alt="" />
          </div>
          <div className="col-lg-7">
            <h2 className=" lh-sm  h2-heading ">
              Organizational Excellence with Blockchain Security Experience the
              Raiden's Difference in blockchain App Development{" "}
            </h2>
            <p className="mt-ld-4 mt-3 h1-para lh-base">
              Our blockchain is built by a mission-driven 50+ talented
              blockchain developers solving real-world problems through digital
              innovation. Regardless of your experience—creator, business owner,
              or privacy enthusiast—our platform offers secure digital ownership
              and direct international connections based on our more than 10
              years of experience. This true digital freedom is provided by
              decentralized, impenetrable technology that enables borderless
              finance. Empower your digital journey with blockchain built for
              the future.
            </p>
          </div>
        </div>
      </div>

      <div className="mt-80 mart">
        <CoreComponent10 comp10={comp11} />
      </div>

      <div className="container mt-80 mart  text-center">
        <h2 className="lh-sm mb-3 h2-heading ">
          Industries We Serve with Blockchain Technology

        </h2>
        <p className="pb-3 h1-para lh-base ">
          Our team of blockchain developers uses blockchain technology
          applications to build your successful path in a variety of industries.
        </p>

        <CoreComponent22 technologiesstack={technologiesstack} />
      </div>

      <div className="container mt-80 mart  text-center">
        <h2 className="lh-sm mb-3 h2-heading ">
          Raiden’s tech stack for Blockchain Development{" "}
        </h2>
        <p className="pb-3 mb-lg-3 h1-para lh-base">
          Raiden's diverse technology stack addresses issues like scalability,
          cost, privacy, and performance for a wide range of applications, from
          private, enterprise-level apps to public, high-volume transactions.
        </p>

        <IndustriesCore industries={industries} />
      </div>

      <div className="  bg-light mt-80 mart ">
        <div className="container">
          <h2 className=" text-center pt-60 padt  lh-sm  h2-heading">
            Our Blockchain Application Development Process
          </h2>
          <p className="text-center mt-lg-4 mt-3 h1-para lh-base">
            The expertise of Raiden Labs enables them to offer more than 100
            blockchain application development solutions that significantly
            boost the innovation of your company.
          </p>
          <DevelopmentProcessCore timelineData={timelineData} />
        </div>
      </div>

      <div className="container pt-80 padt  pb-20">
        <div className=" row">
          <div className="col-lg-4 text-center ">
            <img src={icon2} style={{ width: "75%" }} alt="blockchain" />
          </div>
          <div className="col-lg-8">
            <h2 className=" lh-sm  h2-heading">
              Experience Raiden’s Blockchain Technology
            </h2>
            <p className="mt-lg-4 mt-3  h1-para lh-base">
              Raiden offers unmatched experience and value when choosing your
              partner in developing. We are committed to delivering your product
              with minimal cost without ever compromising on quality. Our team
              of blockchain application development professionals possess
              recognized experience and expertise, which enables each and every
              solution we build to employ the most recent blockchain
              technologies. Intensely adhering to the most advanced innovation
              of our times means that you will get invaluable scalability,
              profitability, and durability all built into your application.
              From start to finish, Raiden proactively looks after its clients,
              offering unparalleled support for all aspects of development.
            </p>
          </div>
        </div>
      </div>

      <div className="container mt-80 mart  ">
        <CoreComponent8 corecontent={corecontent} />
      </div>

      <div className="container text-center mt-80 mart  ">
        <h2 className="lh-sm  h2-heading">
          Partnering for Blockchain Development
        </h2>
        <p className="my-3  h1-para lh-base">
          Embark on your blockchain app development journey with Raiden as your
          steadfast partner.
        </p>

        <Enterpertises3 />
      </div>

      <div>
        <CoreComponent2 />
      </div>

      <div className="border-y-div mb-80 marb pb-50">
        <CoreComponent13 content3={content3} />
      </div>

      <div className="border-y-div m-0">
        <Banner banner={banner} />
      </div>

      <div className="">
        <OurLatestBlogs />
      </div>
      {/* <FaqHome/> */}
      <footer className="theme-footer-two  pt-80 padt">
        <div className="top-footer">
          <div className="container">
            <FooterTwo />
          </div>
        </div>
        <div className="container">
          <div className="bottom-footer-content">
            <CopyRightTwo />
          </div>
        </div>
      </footer>
    </div>
    </>
  );
};

export default BlockChainApp;
